import { forwardRef, useCallback } from 'react';
import { AccessibleIcon } from '@core/components/AccessibleIcon/AccessibleIcon';
import { Badge, Button, Link } from './ControlsButton.styles';
/**
 * Square button used in Player UI (e.g. left caret, X for close, kebab menu).
 * Adds plain circle "badge" and wraps <AccessibleIcon />.
 */
export const ControlsButton = forwardRef((props, ref) => {
    const { badge = false, size = 40, imgSize, src, hideImage, className, asLink = false, ...rest } = props;
    /**
     * on android devices we want to hide outline when mouse/touch even used and
     * keep it for keyboard users, instead of removing outline we blur when
     * mouse/touch used
     */
    const handleBlur = useCallback((event) => {
        setTimeout(() => {
            event.target.blur();
        }, 0);
    }, []);
    const Component = (asLink ? Link : Button);
    return (<Component ref={ref} size={size} {...rest} aria-label={rest['aria-label']} onMouseUp={handleBlur} className={className}>
      {!hideImage && src && (<AccessibleIcon src={src} label={rest['aria-label'] || ''} width={`${imgSize || size}px`} height={`${imgSize || size}px`}/>)}
      {badge && <Badge />}
    </Component>);
});
